<!--
 * @Description: 特材入库
-->
<template>
  <el-dialog :visible="visible" width="880px" :close-on-click-modal="false" :modal-append-to-body="true"  @close="onClose" @open="onOpen">
    <span slot="title" class="dialog-title">查看详情</span>
    <div class="dialoginfo">
      <el-form :inline="true" label-width="110px" :disabled="true">
        <div>
          <el-form-item>
            <span slot="label">供应商：</span>
            <div class="text1" style="width: 280px">四川华西绿舍建材有限公司特材库</div>
          </el-form-item>
          <el-form-item>
            <span slot="label">状态：</span>
            <div class="text1" style="width: 280px">已收货</div>
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <span slot="label">成品名称：</span>
            <div class="text1" style="width: 280px">{{ config.name }}</div>
          </el-form-item>
          <el-form-item>
            <span slot="label">成品型号：</span>
            <div class="text1" style="width: 280px">{{ config.model }}</div>
          </el-form-item>
        </div>
        <el-form-item>
          <span slot="label">入场时间：</span>
          <div class="text1" style="width: 280px">{{ config.firstWeightTime || "" }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">出场时间：</span>
          <div class="text1" style="width: 280px">{{ config.secondWeightTime || "" }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label">需求主体：</span>
          <div class="text1" style="width: 280px">{{ config.neddSubject || "" }}</div>
        </el-form-item>
        <div class="col">
          <div>
            <el-form-item>
              <span slot="label" style="line-height: 133px">收货量：</span>
              <el-input  v-model.trim="config.receiveVolume" class="receiveNum" type="number"></el-input>
            </el-form-item>
          </div>
          <div>
            <div>
              <el-form-item>
                <span slot="label">毛重：</span>
                <div class="text1" style="width: 160px">{{ config.grossWeight || 0 }}</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item>
                <span slot="label">皮重：</span>
                <div class="text1" style="width: 160px">{{ config.tare || 0 }}</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item>
                <span slot="label">净重：</span>
                <div class="text1" style="width: 160px">{{ config.suttle || 0 }}</div>
              </el-form-item>
            </div>
          </div>
        </div>
        <el-form-item>
          <span slot="label">备注</span>
          <div class="text1" style="width: 550px">{{ config.remark || "" }}</div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      指定打印模板：
      <el-select v-model="printIndex">
        <el-option v-for="(item, index) in printTemplateList" :key="index" :value="item.templateId" :label="item.templateName"></el-option>
      </el-select>
      <span>
        <el-button class="bottom_all" @click="print" >打 印</el-button>
      </span>
      <span>
        <el-button class="bottom_all_two" style="margin-left: 24px" @click="onClose">关 闭</el-button>
      </span>
    </span>

    <Printer
      v-if="visible"
      ref="raw-printer"
      :secondKey="secondKey"
      :data="config"
      :userName="userInfo.userRealName"
      :userSelectIndex="printIndex"
      @confList="getPrintTemplate"
      @closeDialog="closeDialog"
    ></Printer>
  </el-dialog>
</template>

<script>
import { getUserInfo } from "@/utils/auth";
import Printer from "@/views/components/Printer.vue";
export default {
  components: { Printer },
  data() {
    return {
      printIndex: "",
      userInfo: "",
      isPrint:false,
      secondKey: "",
    };
  },
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    printTemplateList: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    stationId: {
      type: String,
      default: "",
    },
    status: {
      type: String,
    },
  },
  watch: {
    printTemplateList(val) {
      if (val) {
        this.getPrintTemplate(val);
      }
    },
  },
  async mounted() {
    this.userInfo = await getUserInfo();
  },
  methods: {
    onOpen() {
      console.log(this.config);
      this.config.receiveVolume = this.config.receiveVolume || 0;
      switch (this.status) {
        case "TCRK":
          this.secondKey = "specialMaterialIn";
          break;

        case "TCFL":
          this.secondKey = "specialMaterialOut";
          break;

        default:
          break;
      }
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    closeDialog() {
      this.isPrint = false;
    },
    print() {
      this.isPrint = true
      this.$nextTick(() => {
          this.$refs["raw-printer"].print();
        });
    },
    getPrintTemplate() {
      let list = this.printTemplateList
      //整理conditionList和模板id
      let conditionDes = [];
      list.forEach(item => {
        let conditionObj = {};
        conditionObj.stationTemplateId = item.stationTemplateId;
        item.conditionList.forEach(ite => {
          conditionObj[ite.conditionName] = ite.conditionData;
        });
        conditionDes.push(conditionObj);
      });
      //对比conditionDes和this.config
      let checkSame = condition => {
        let a = condition.find(item => {
          //不考虑["stationTemplateId","brand","originPlace","transportUnit"]这些属性是否相同
          let a = Object.keys(item).filter(item => !["stationTemplateId", "brand", "originPlace", "transportUnit"].find(ite => item == ite));
          //判断剩下的属性值是否和low的相同
          let sameLength = 0;
          a.forEach(ite => {
            if (ite == "isFirstSupply") {
              let isFirstSupply = this.config[ite] == 1 ? "Y" : "N";
              if (item[ite] === isFirstSupply) {
                sameLength++;
              }
            } else {
              if (item[ite] === this.config[ite]) {
                sameLength++;
              }
            }
          });
          //找出low和condition属性全部相同的哪个对象并返回id
          return sameLength == a.length;
        });
        if (a == undefined) {
          return 0;
        }
        return a.stationTemplateId;
      };
      if (this.config.templateId) {
        this.printIndex = this.config.templateId;
      } else {
        if (checkSame(conditionDes) != 0) {
          let marryTemplate = this.printTemplateList.find(item => item.stationTemplateId == checkSame(conditionDes));
          this.printIndex = marryTemplate.templateId;
        } else {
          this.printIndex = this.printTemplateList[0].templateId;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.receiveNum {
  .el-input__inner {
    width: 133px;
    height: 133px;
  }
}
.col {
  display: flex;
  align-items: center;
}
</style>